import { useTranslation } from 'react-i18next';
import { IconButton, ListItemMeta } from '@salecycle/ui-component-library';
import { ListItem } from '@salecycle/ui-component-library';
import { ConsentFileData, RAGStatus } from '../types';
import { useImportConsentContext } from '../context/ImportConsentContext';

interface Props {
  fileData: ConsentFileData;
  removeFile(id: string): void;
}

export function ConsentListItem({ fileData, removeFile }: Props) {
  const { t } = useTranslation('fileManagement');
  const { setAnalysedFileData, setAnalysedFileModalVisibility } = useImportConsentContext();

  return (
    <>
      <ListItem
        onClick={() => {
          setAnalysedFileData(fileData);

          if (fileData.status.type !== RAGStatus.GREEN) {
            setAnalysedFileModalVisibility(true);
          }
        }}
        variation="full-border"
        status={fileData.status}
        options={
          <IconButton
            ariaLabel={t('analysis.dropArea.removeFile')}
            icon="trash"
            onClick={event => {
              event.stopPropagation();
              removeFile(fileData.fileName);
            }}
          />
        }
      >
        <ListItemMeta description={fileData.fileName} />
      </ListItem>
    </>
  );
}
